import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import truncate from 'lodash/truncate';
import DropdownListWrapper from './styled';

const MAX_OPTION_LENGTH = 60;

class DropdownList extends PureComponent {
    render() {
        let index = 1;
        const keyAttr = !this.props.optionKey ? 'key' : this.props.optionKey;
        const stringAttr = !this.props.optionText ? 'value' : this.props.optionText;

        // Custom label generator that uses function to use current item's properties
        const { customLabelFn } = this.props;
        const customItemLabelGenerator = customLabelFn || (() => {});

        const listOptions = this.props.options ? this.props.options.map((option) => {
            const text = customLabelFn ? customItemLabelGenerator(option) : option[stringAttr];
            const truncatedText = truncate(text, { length: this.props.optionLength > 0 ? this.props.optionLength : MAX_OPTION_LENGTH });
            index += 1;
            const disabled = option.disabled ? { disabled: 'disabled' } : {};
            return (
                <option
                    {...disabled}
                    key={`${option[keyAttr]}_${index}`}
                    title={text}
                    value={option[keyAttr]}
                >
                    {truncatedText}
                </option>
            );
        }) : '';

        let placeholderText = '';

        if (this.props.isLoading) {
            placeholderText = this.props.loadingPlaceholder ? this.props.loadingPlaceholder : `${this.props.placeholder} ...`;
        } else {
            placeholderText = this.props.placeholder;
        }
        const placeholderOption = this.props.placeholder ? (
            <option
                key="-1"
                value=""
            >
                {placeholderText}
            </option>
        ) : '';

        const isDropdownDisabled = this.props.disabled ? { disabled: 'disabled' } : {};
        return (
            <DropdownListWrapper>
                <select
                    {...isDropdownDisabled}
                    name={this.props.name}
                    onChange={(e) => {
                        this.props.onChange(e.currentTarget.name, e.currentTarget.value);
                    }}
                    value={this.props.value}>
                    {placeholderOption}
                    {listOptions}
                </select>
                <div className="icon" />
            </DropdownListWrapper>
        );
    }
}

DropdownList.propTypes = {
    css: PropTypes.object,
    customLabelFn: PropTypes.func,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    loadingPlaceholder: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    optionLength: PropTypes.number,
    optionKey: PropTypes.string,
    optionText: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    variant: PropTypes.string
};

export default DropdownList;



// WEBPACK FOOTER //
// ./app/components/dropdown-list/index.js